import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Flex } from '@chakra-ui/react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import { useGlobalState } from 'state-pool';
import ComponentMiniature from '../canvas/ComponentMiniature';
import CloneCM from '../canvas/CloneCM';

const miniatureStyle = {
	className: 'component-miniature',
	margin: '0',
	p: 2,
	textAlign: 'center',
	color: 'black',
	fontSize: 'sm',
	borderRadius: 'md',
	fontWeight: 'bold',
	backgroundColor: '#e6e6e6',
};

const SelectDraggableComponent = ({ components, ind }) => {
	const [id] = React.useState(uuidv4());

	return (
		<Droppable isDropDisabled={true} droppableId={'AvailableComponents-' + id + ind} index={ind} key={'pscd-' + ind}>
			{(providedDropTwo) => (
				<Flex
					position={'relative'}
					flexDir={'column'}
					sx={{ gap: '8px' }}
					ref={providedDropTwo.innerRef}
					{...providedDropTwo.droppableProps}
				>
					{components &&
						!!components.length &&
						components.map((comp, index) => {
							return (
								<Draggable
									isDragDisabled={false}
									draggableId={comp.id}
									index={index}
									key={'available-draggable-' + index}
								>
									{(providedDrag, snapshotDrag) => (
										<React.Fragment>
											<ComponentMiniature
												index={index}
												innerRef={providedDrag.innerRef}
												isDragging={snapshotDrag.isDragging}
												providedDrag={providedDrag}
												miniatureStyle={miniatureStyle}
												{...comp}
											/>

											{snapshotDrag.isDragging && <CloneCM {...comp} miniatureStyle={miniatureStyle} />}
											{providedDrag.placeholder}
										</React.Fragment>
									)}
								</Draggable>
							);
						})}
					{providedDropTwo.placeholder}
				</Flex>
			)}
		</Droppable>
	);
};

export default SelectDraggableComponent;
